module.exports = {"body":"<p>Enhancing your living space can go a long way to making you home a more enjoyable\nplace to be. Installing energy efficient gas fireplaces and custom built entertainment\ncenters can turn an ordinary room into “the place to be”.</p>\n<p>Whether you decide to add more space by way of an addition or up grade the space you currently have, Enhanced Interiors Remodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/LivingRoom.md
// module id = 515
// module chunks = 0